import type { JSX, Signal } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import { getCSSColorBg } from '~/utilities/getCSS';

const menuIconSpan = cva(
  'block absolute h-0.5 ease-in-out duration-200 origin-right-center opacity-1',
  {
    variants: {
      color: getCSSColorBg(),
      order: {
        first: '',
        second: '',
        third: '',
      },
      active: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        order: 'first',
        active: false,
        class: 'top-1 w-full',
      },
      {
        order: 'second',
        active: false,
        class: 'top-3 w-full',
      },
      {
        order: 'third',
        active: false,
        class: 'top-5 w-full',
      },
      {
        order: 'first',
        active: true,
        class: 'top-0 -left-2 w-[130%] -rotate-45',
      },
      {
        order: 'second',
        active: true,
        class: 'top-[7px] left-0 w-full opacity-0 scale-x-[0.1]',
      },
      {
        order: 'third',
        active: true,
        class: 'top-[22px] -left-2 w-[130%] rotate-45',
      },
    ],
  }
);

type MobileIconType = {
  mobileActive: Signal<boolean>;
};

export default component$(({ mobileActive }: MobileIconType): JSX.Element => {
  const appData = useContext(AppDataContext);

  return (
    <div
      class='block lg:hidden w-6 h-6 min-w-[24px] relative mr-5 cursor-pointer'
      onClick$={() => {
        mobileActive.value = !mobileActive.value;
      }}
    >
      <span
        class={menuIconSpan({
          order: 'first',
          color: appData.themeComponents.header.hamburgerMenuIconColor.value,
          active: mobileActive.value,
        })}
      />
      <span
        class={menuIconSpan({
          order: 'second',
          color: appData.themeComponents.header.hamburgerMenuIconColor.value,
          active: mobileActive.value,
        })}
      />
      <span
        class={menuIconSpan({
          order: 'third',
          color: appData.themeComponents.header.hamburgerMenuIconColor.value,
          active: mobileActive.value,
        })}
      />
    </div>
  );
});
